import { render, staticRenderFns } from "./StockPerBuyer.vue?vue&type=template&id=7d535224&"
import script from "./StockPerBuyer.vue?vue&type=script&lang=js&"
export * from "./StockPerBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports